export default __webpack_public_path__ + "static/media/bg-value-Opportunities.b50a9ad9.jpg";